import { Translatable } from 'Shared/TranslatableTextContent/translatable'

export type ActionTranslatableKeysCustom = 'skipButtonText' | 'content'
export const actionTranslatablesCustomAction: Record<ActionTranslatableKeysCustom, Translatable> = {
    skipButtonText: {
        label: 'Skip Button Text',
        default: 'Skip',
    },
    content: {
        label: 'Content',
        default: '',
    }
} as const

type ActionTranslatableKeysThankYouEmail = 'thankYouSubject' | 'thankYouBody'
const actionTranslatablesThankYouEmail: Record<ActionTranslatableKeysThankYouEmail, Translatable> = {
    thankYouSubject: { label: 'Thank You Subject' },
    thankYouBody: { label: 'Thank You Body' },
} as const

export type ActionTranslatableKeysSurvey = 'introText' | 'privacyText' | 'petitionReason' | 'petitionAsk' | 'eventInfoHeader' | 'eventShortDescription' | 'eventDescription' | 'buttonTextSubmit' | 'openFormMobileButton' | 'signatureCountText' | ActionTranslatableKeysThankYouEmail
export const actionTranslatablesSurvey: Record<ActionTranslatableKeysSurvey, Translatable> = {
    introText: { label: 'Intro Text', hideIfNotPresent: true },
    privacyText: { label: 'Privacy Text', hideIfNotPresent: true },
    petitionReason: { label: 'Why is this imporant?', hideIfNotPresent: true },
    petitionAsk: { label: 'What are you asking for?', hideIfNotPresent: true },
    eventInfoHeader: { label: 'Event Info Header', hideIfNotPresent: true },
    eventShortDescription: { label: 'Event Short Description', hideIfNotPresent: true },
    eventDescription: { label: 'Event Description', hideIfNotPresent: true },
    buttonTextSubmit: { label: 'Button Text Submit', hideIfNotPresent: true },
    openFormMobileButton: { label: 'Open Form Mobile Button', hideIfNotPresent: true },
    signatureCountText: { label: 'Signature Count Text', default: 'of {{ petitionTarget }} signatures', hideIfNotPresent: false },
    ...actionTranslatablesThankYouEmail,
} as const

export type ActionTranslatableKeysDonations = 'petitionReason' | 'donateButtonText' | 'donateButtonTextMonthly' | 'monthlyUpsellText' | 'monthlyUpsellButton' | 'oneOffButton' | 'coverFeeText' | 'secureDonationText'
 | 'giveOnceText' | 'monthlyText' | 'monthlyUpsellHeader' | 'monthlyUpsellReturnText' | 'minimumAmountText' | 'maximumAmountText' | 'donatingAsText' | 'notMeText' | ActionTranslatableKeysThankYouEmail
export const actionTranslatablesDonations: Record<ActionTranslatableKeysDonations, Translatable> = {
    ...actionTranslatablesThankYouEmail,
    petitionReason: { label: 'Why is this imporant?', hideIfNotPresent: true },
    donateButtonText: { label: 'Donate Button Text', default: 'Donate {{ amount }}' },
    donateButtonTextMonthly: { label: 'Donate Button Text Monthly', default: 'Donate {{ amount }} monthly' },
    monthlyUpsellText: { label: 'Monthly Upsell Text' },
    monthlyUpsellButton: { label: 'Monthly Upsell Button' },
    oneOffButton: { label: 'One Off Button' },
    coverFeeText: { label: 'Cover Fee Text' },
    secureDonationText: { label: 'Secure Donation Text', default: 'Secure Donation' },
    giveOnceText: { label: 'Give Once Text', default: 'Give once' },
    monthlyText: { label: 'Monthly Text', default: 'Monthly' },
    monthlyUpsellHeader: { label: 'Monthly Upsell Header', default: 'Will you make it monthly?' },
    monthlyUpsellReturnText: { label: 'Monthly Upsell Return Text', default: 'Back' },
    minimumAmountText: { label: 'Minimum Amount Text', default: 'The minimum amount is {{ amount }}' },
    maximumAmountText: { label: 'Maximum Amount Text', default: 'The maximum amount is {{ amount }}' },
    donatingAsText: { label: 'Donating As Text', default: "You're donating as" },
    notMeText: { label: 'Not Me Text', default: 'Not me' },
} as const

export type ActionTranslatableKeysEmailToTarget = 'privacyText' | 'petitionAsk' | 'ettContent' | 'userInstructionsContent' | 'enterYourPostcode' | 'enterYourPostcodePlaceholder' | 'findMyMp' | 'skipButtonText' | 'sendEmailButtonText' | 'emailFormHeaderText' | 'selectPeopleToEmailText' | 'subjectText' | 'salutationText' | 'editBodyValidationMessage' | 'emailSignOffText' |
'namePlaceholder' | 'emailPlaceholder' | 'addressPlaceholder' | 'cityPlaceholder' | 'postcodePlaceholder' | 'invalidLookupValidationMessage' | 'noDecisionMakersFoundMessage' | 'otherLookupErrorMessage' | 'footerContent' |
'validationEmail' | 'validationPostcode' | 'validationEnterAResponse' | 'selectAtLeastOnePersonValidation' | 'subjectRequiredValidation' | 'emailBodyRequiredValidation' | 'subjectPlaceholder' | 'validationName' | 'validationAddress' | 'validationCity' | 'usingSignedInAsLabel' | 'notMeText' | 'optInLabel' | ActionTranslatableKeysThankYouEmail
export const actionTranslatablesEmailToTarget: Record<ActionTranslatableKeysEmailToTarget, Translatable> = {
    ...actionTranslatablesThankYouEmail,
    privacyText: { label: 'Privacy Text', hideIfNotPresent: true },
    petitionAsk: { label: 'What are you asking for?', hideIfNotPresent: true },
    ettContent: { label: 'ETT Content', hideIfNotPresent: true },
    // Lookup Form
    enterYourPostcode: { label: 'Enter Your Postcode', default: 'Enter your postcode to email your MP' },
    enterYourPostcodePlaceholder: { label: 'Enter Your Postcode Placeholder', default: 'Enter your postcode' },
    findMyMp: { label: 'Find My MP', default: 'Find my MP' },
    skipButtonText: { label: 'Skip Button Text', default: 'Skip' },
    invalidLookupValidationMessage: { label: 'Invalid Lookup Validation Message', default: 'Please check the postcode you\'ve entered is correct.' },
    noDecisionMakersFoundMessage: { label: 'No Recipients Found Message', default: "Sorry, we've not got anyone for you to email." },
    otherLookupErrorMessage: { label: 'Other Lookup Error Message', default: "An error occurred. Please try again." },
    // Email Form
    userInstructionsContent: { label: 'User Instructions Content' },
    sendEmailButtonText: { label: 'Send Email Button Text', default: 'Send Email' },
    emailFormHeaderText: { label: 'Email Form Header', default: 'Email {{ names }}' },
    selectPeopleToEmailText: { label: 'Select People To Email', default: 'Select people to email:' },
    subjectText: { label: 'Subject', default: 'Subject' },
    salutationText: { label: 'Salutation', default: 'Dear {{ name }},' },
    emailSignOffText: { label: 'Email Sign Off Text', default: 'Yours sincerely,' },
    namePlaceholder: { label: 'Name Placeholder', default: 'Your name' },
    emailPlaceholder: { label: 'Email Placeholder', default: 'Your email address' },
    addressPlaceholder: { label: 'Address Placeholder', default: 'First line of address' },
    cityPlaceholder: { label: 'City Placeholder', default: 'Town' },
    postcodePlaceholder: { label: 'Postcode Placeholder', default: 'Postcode' },
    editBodyValidationMessage: { label: 'Edit Body Validation Message', default: 'You must edit the body of the email before sending.' },
    footerContent: { label: 'Footer Content' },
    validationEmail: { label: 'Validation Email', default: 'Please check your email address is correct' },
    validationPostcode: { label: 'Validation Postcode', default: 'Please check your postcode is correct' },
    validationEnterAResponse: { label: 'Validation Enter A Response', default: 'Please enter a response' },
    selectAtLeastOnePersonValidation: { label: 'Select At Least One Person Validation', default: 'Please select at least one person to email' },
    subjectRequiredValidation: { label: 'Subject Required Validation', default: 'Subject is required' },
    emailBodyRequiredValidation: { label: 'Email Body Required Validation', default: 'Email body is required' },
    validationName: { label: 'Validation Name', default: 'Please enter your name' },
    validationAddress: { label: 'Validation Address', default: 'Please enter your address' },
    validationCity: { label: 'Validation City', default: 'Please enter your town' },
    usingSignedInAsLabel: { label: 'Using Signed In As Label', default: 'Using saved information for' },
    notMeText: { label: 'Not Me Text', default: 'Not me' },
    optInLabel: { label: 'Opt-in Label', default: 'Keep me updated with news and campaigns' },
} as const

export type ActionTranslatableKeysShare = 'shareLinkText' | 'shareWhatsapp' | 'shareFacebook' | 'shareTwitter' | 'shareLinkedin' | 'shareBluesky' | 'shareNative' | 'copyLinkToShare' | 'copied' | 'continueOnceShared' | 'skipButtonText'
export const actionTranslatablesShare: Record<ActionTranslatableKeysShare, Translatable> = {
    shareLinkText: { label: 'Share Link Text', default: 'Share Link' },
    copyLinkToShare: { label: 'Copy Link to Share', default: 'Copy this link to share' },
    copied: { label: 'Copied', default: 'Copied!' },
    skipButtonText: { label: 'Skip step', default: 'Skip this step' },
    continueOnceShared: { label: 'Continue once shared', default: 'Continue' },
    shareWhatsapp: { label: 'Share on WhatsApp', default: 'Share on WhatsApp' },
    shareFacebook: { label: 'Share on Facebook', default: 'Share on Facebook' },
    shareTwitter: { label: 'Share on Twitter', default: 'Share on X' },
    shareLinkedin: { label: 'Share on LinkedIn', default: 'Share on LinkedIn' },
    shareBluesky: { label: 'Share on Bluesky', default: 'Share on Bluesky' },
    shareNative: { label: 'Share', default: 'Share' },

} as const

export type ActionTranslatableKeys = ActionTranslatableKeysCustom | ActionTranslatableKeysSurvey | ActionTranslatableKeysDonations | ActionTranslatableKeysEmailToTarget | ActionTranslatableKeysShare
export const actionTranslatables: Record<ActionTranslatableKeys, Translatable> = {
    ...actionTranslatablesCustomAction,
    ...actionTranslatablesSurvey,
    ...actionTranslatablesDonations,
    ...actionTranslatablesEmailToTarget,
    ...actionTranslatablesShare,
} as const
